import styled from 'styled-components';
import { Captions, ShortBody } from 'components/Typography';
import { Grid } from '@material-ui/core';
import { REQUESTS_STATUSES } from 'constants/amcStatuses';

export const StyledCaption = styled(Captions)`
  && {
    color: #9797af;
    font-size: 13px !important;
    margin: 1px !important;
  }
`;
export const StyledShortBody = styled(ShortBody)`
  && {
    font-weight: 500;
    margin-bottom: 0;
  }
`;
export const StyledLink = styled.a`
  && {
    text-decoration: none;
  }
`;

export const AlignedGrid = styled(Grid)`
  align-self: center;
`;

export const SizedGrid = styled(Grid)`
  min-height: 200px;
`;

export const COLOR_BY_REQUEST_STATUS: any = {
  [REQUESTS_STATUSES.CREATED]: '#fcb718',
  [REQUESTS_STATUSES.VALIDATED]: '#6Fad37',
  [REQUESTS_STATUSES.REJECTED]: '#d20b24',
  DEFAULT: '#fcb718',
};

export const BOX_SIZE_BY_REQUEST_STATUS: any = {
  [REQUESTS_STATUSES.REJECTED]: '70%',
  [REQUESTS_STATUSES.VALIDATED]: '70%',
};
